// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sign_up-container {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  align-items: center;
  height: 60vh;
  /*background-color: #f5f5f5;*/
}

.sign_up-box {
  padding: 30px;
  border: 1px solid #ddd;
  border-radius: 5px;    
background-color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}


.input-group {
  margin-bottom: 1px;
}

.input-field {
  width: 250px;
  padding: 10px;
  margin: 5px 0;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.input-field#CCC {
  width: 180px;
}

.sign-up-action-button {
  width: 100%;
  padding: 10px;
  background-color: #DCC1B5;; border:1px solid #DCC1B5;
  color: #fff;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  margin: 0px;
}

.sign-up-action-button:hover {
  background-color: #fff;color:#947728;border:1px solid #d4a300
}
.sign-up-action-button#PIN_button:disabled {
  background-color: #ccc; 
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/sign_up.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB,0CAA0C;EACxC,uCAAuC;AACzC;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB,GAAG,wBAAwB;EACpD,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB,CAAC,aAAa,CAAC;AACvC;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":["\n.sign_up-container {\n  display: flex;\n  flex-direction: column;\n  /*justify-content: center;*/\n  align-items: center;\n  height: 60vh;\n  /*background-color: #f5f5f5;*/\n}\n\n.sign_up-box {\n  padding: 30px;\n  border: 1px solid #ddd;\n  border-radius: 5px;    \nbackground-color: rgba(255, 255, 255, 0.8);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n\n.input-group {\n  margin-bottom: 1px;\n}\n\n.input-field {\n  width: 250px;\n  padding: 10px;\n  margin: 5px 0;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.input-field#CCC {\n  width: 180px;\n}\n\n.sign-up-action-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #DCC1B5;; border:1px solid #DCC1B5;\n  color: #fff;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  margin: 0px;\n}\n\n.sign-up-action-button:hover {\n  background-color: #fff;color:#947728;border:1px solid #d4a300\n}\n.sign-up-action-button#PIN_button:disabled {\n  background-color: #ccc; \n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
